import React from "react";
import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, WhatsappLogo, Sun } from "@phosphor-icons/react";
import { CONTACT } from "../lib/api";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0A1F15] text-white/90 pt-20 pb-8" data-testid="main-footer">
      <div className="container-custom">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-10 h-10 rounded-xl bg-[#FDB813] flex items-center justify-center">
                <Sun weight="fill" size={22} className="text-[#0A1F15]"/>
              </div>
              <div>
                <div className="font-display font-extrabold text-xl text-white">Orax Solar</div>
                <div className="text-[10px] uppercase tracking-[0.15em] text-white/60">Akola · Maharashtra</div>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-5">
              Akola's most trusted solar installation company since 2015. Powering homes, businesses and industries with clean solar energy.
            </p>
            <a
              href={`https://wa.me/91${CONTACT.whatsapp}?text=Hi%20Orax%20Solar,%20I%20am%20interested%20in%20solar%20installation.`}
              target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] text-white text-sm font-semibold hover:-translate-y-0.5 transition"
              data-testid="footer-whatsapp"
            >
              <WhatsappLogo weight="fill" size={18} /> WhatsApp Us
            </a>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-[#FDB813]">Services</h4>
            <ul className="space-y-2 text-sm text-white/75">
              <li><Link to="/services/residential" className="hover:text-white">Residential</Link></li>
              <li><Link to="/services/commercial" className="hover:text-white">Commercial</Link></li>
              <li><Link to="/services/industrial" className="hover:text-white">Industrial</Link></li>
              <li><Link to="/services/maintenance" className="hover:text-white">Maintenance</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-[#FDB813]">Company</h4>
            <ul className="space-y-2 text-sm text-white/75">
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/projects" className="hover:text-white">Projects</Link></li>
              <li><Link to="/calculator" className="hover:text-white">Calculator</Link></li>
              <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-4 text-[#FDB813]">Contact</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-3">
                <Phone weight="bold" size={18} className="text-[#FDB813] mt-0.5 shrink-0"/>
                <div>
                  <a href={`tel:${CONTACT.phonePrimary}`} className="hover:text-white block">+91 {CONTACT.phonePrimary}</a>
                  <a href={`tel:${CONTACT.phoneSecondary}`} className="hover:text-white block">+91 {CONTACT.phoneSecondary}</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <EnvelopeSimple weight="bold" size={18} className="text-[#FDB813] mt-0.5 shrink-0"/>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin weight="bold" size={18} className="text-[#FDB813] mt-0.5 shrink-0"/>
                <span>{CONTACT.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {year} Orax Solar. All rights reserved. Akola, Maharashtra.</p>
          <div className="flex gap-4">
            <Link to="/admin/login" className="hover:text-white/80">Admin</Link>
            <a href="/sitemap.xml" className="hover:text-white/80">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
